<div class="pt-3 pl-md-4" *ngIf="challengeNotFound">
  <h2>Challenge not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingChallenge">
  <h2>Loading Challenge...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewChallenge ? 'create' : 'edit' }}
    challenges.
  </h2>
</div>

<div *ngIf="(serverError === null) && !challengeNotFound && !loadingExistingChallenge && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/challenges" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <!-- No internal navigation (yet) for challenges -->
    </ul>

    <form class="form-inline">
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="loadingSubmit" [disabled]="loadingSubmit"
              type="button" (click)="handleSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 pb-5">
      <h2>
        {{ isNewChallenge ? 'New Challenge' : 'Edit Challenge' }}
      </h2>

      <form (submit)="handleSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8">

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="nameInput">Name</label>
                  <input id="nameInput" type="text" name="name"
                         class="form-control"
                         [(ngModel)]="challenge.name">
                </div>
              </div>
              <small class="form-text text-muted">
                This will be displayed to customers taking part in the challenge.
              </small>
              <div class="form-text text-danger">{{ errors.name }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="statusSelect">Status</label>
                  <select id="statusSelect" name="status"
                          class="custom-select"
                          [(ngModel)]="challenge.status">
                    <option *ngFor="let status of getAvailableStatuses()"
                            [ngValue]="status">
                      {{ getChallengeStatusDisplay(status) }}
                    </option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                Once a challenge is set to Active (or Retired), it may not be reverted to Draft. Only Active challenges will be displayed in the Climber App, and any settings to automatically add customers will only be applied while the challenge is Active.
              </small>
              <small class="form-text text-muted">
                If a challenge is changed to Retired, it will no longer be visible in the Climber App, even to customers who have completed it. In order to leave an ended challenge visible in the Climber App, keep it in the Active state, and instead add an End Date.
              </small>
              <div class="form-text text-danger">{{ errors.status }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-10">
                  <label for="descriptionTextArea">Description</label>
                  <textarea id="descriptionTextArea" name="description"
                            class="form-control"
                            [(ngModel)]="challenge.description"></textarea>
                </div>
              </div>
              <small class="form-text text-muted">
                Use this space to describe the challenge requirements and prizes.
              </small>
              <div class="form-text text-danger">{{ errors.description }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-10">
                  <label for="detailsTextArea">Details (optional)</label>
                  <textarea id="detailsTextArea" name="details"
                            class="form-control"
                            [(ngModel)]="challenge.details"></textarea>
                </div>
              </div>
              <small class="form-text text-muted">
                Use this space to add any clarifying information for your challenge, such as eligibility and terms.
              </small>
              <div class="form-text text-danger">{{ errors.details }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="goalInput">Required Number of Check-Ins</label>
                  <input id="goalInput" type="number" name="goal"
                         min="1"
                         class="form-control"
                         [(ngModel)]="challenge.goal">
                </div>
              </div>
              <small class="form-text text-muted">
                The customer must check in this many times in the designated time frame in order to complete the challenge.
              </small>
              <div class="form-text text-danger">{{ errors.goal }}</div>
            </div>

            <div class="form-group">
              <label class="mb-1">Availability (optional)</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <div class="row">
                    <div class="col">
                      <label for="availabilityStartInput">Start Date</label>
                      <app-date-picker [id]="'availabilityStartInput'"
                                       [(content)]="challenge.availability_start"></app-date-picker>
                      <div class="form-text text-danger">{{ errors.availability_start }}</div>
                    </div>
                    <div class="col">
                      <label for="availabilityEndInput">End Date</label>
                      <app-date-picker [id]="'availabilityEndInput'"
                                       [(content)]="challenge.availability_end"></app-date-picker>
                      <div class="form-text text-danger">{{ errors.availability_end }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If provided, these dates limit when customers can be added to this challenge.
              </small>
            </div>

            <div class="form-group">
              <label class="mb-1">Automatically add customers to challenge</label>
              <div class="form-check">
                <input id="autoAddNewCustomersCheckbox" type="checkbox"
                       name="auto_add_new_customers"
                       class="form-check-input"
                       [(ngModel)]="challenge.auto_add_new_customers">
                <label class="form-check-label" for="autoAddNewCustomersCheckbox">
                  New customers created during challenge availability
                </label>
                <div class="form-text text-danger">{{ errors.auto_add_new_customers }}</div>
              </div>
              <div class="form-check">
                <input id="autoAddOnCheckInCheckbox" type="checkbox"
                       name="auto_add_on_check_in"
                       class="form-check-input"
                       [(ngModel)]="challenge.auto_add_on_check_in">
                <label class="form-check-label" for="autoAddOnCheckInCheckbox">
                  Customers who check in during challenge availability
                </label>
                <div class="form-text text-danger">{{ errors.auto_add_on_check_in }}</div>
              </div>
              <small class="form-text text-muted">
                Customers can also be manually added to challenges from their customer profile and via a bulk action.
              </small>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input id="hideInClimberAppCheckbox" type="checkbox"
                       name="hide_in_climber_app"
                       class="form-check-input"
                       [(ngModel)]="challenge.hide_in_climber_app">
                <label class="form-check-label" for="hideInClimberAppCheckbox">
                  Hide challenge in Climber App
                </label>
                <div class="form-text text-danger">{{ errors.hide_in_climber_app }}</div>
              </div>
              <small class="form-text text-muted">
                This will remove the challenge card (description, progress bar, and time limit) from the Climber App. Use this setting to make completing the challenge a surprise for the customer (for example, with long-running lifetime challenges).
              </small>
            </div>

            <div class="form-group">
              <label class="mb-1">Duration type</label>
              <div class="form-check">
                <input id="hasSetLengthOfTimeFalse"
                       type="radio"
                       name="hasSetLengthOfTimeFalse"
                       class="form-check-input"
                       [(ngModel)]="hasSetLengthOfTime" [value]="false">
                <label class="form-check-label" for="hasSetLengthOfTimeFalse">
                  Date range
                </label>
                <small class="form-text text-muted mt-0">
                  The start and end date will be the same for all customers on the challenge. For lifetime challenges, leave the start and end dates blank.
                </small>
              </div>
              <div class="form-check mt-1">
                <input id="hasSetLengthOfTimeTrue"
                       type="radio"
                       name="hasSetLengthOfTimeTrue"
                       class="form-check-input"
                       [(ngModel)]="hasSetLengthOfTime" [value]="true">
                <label class="form-check-label" for="hasSetLengthOfTimeTrue">
                  Length of time
                </label>
                <small class="form-text text-muted mt-0">
                  When a customer is added to the challenge, the end date will be calculated from when they are first added.
                </small>
              </div>
            </div>

            <ng-container *ngIf="!hasSetLengthOfTime">
              <div class="form-group">
                <label class="mb-1">Duration date range (optional)</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <div class="row">
                      <div class="col">
                        <label for="challengeStartInput">Start Date</label>
                        <app-date-picker [id]="'challengeStartInput'"
                                         [(content)]="challenge.challenge_start"></app-date-picker>
                        <div class="form-text text-danger">{{ errors.challenge_start }}</div>
                      </div>
                      <div class="col">
                        <label for="challengeEndInput">End Date</label>
                        <app-date-picker [id]="'challengeEndInput'"
                                         [(content)]="challenge.challenge_end"></app-date-picker>
                        <div class="form-text text-danger">{{ errors.challenge_end }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, these dates determine the time range over which the check-ins must occur for this challenge.
                </small>
              </div>
            </ng-container>

            <ng-container *ngIf="hasSetLengthOfTime">
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <label for="challengeDurationDaysInput">Duration</label>
                    <div class="input-group">
                      <input id="challengeDurationDaysInput" type="number"
                             name="challenge_duration_days"
                             min="1" required
                             class="form-control"
                             [(ngModel)]="challenge.challenge_duration_days">
                      <div class="input-group-append">
                        <span class="input-group-text">days</span>
                      </div>
                    </div>
                  </div>
                </div>
                <small class="form-text text-muted">
                  This is the number of days the customer has to check in the required number of times, starting on the day they are added to the challenge.
                </small>
                <div class="form-text text-danger">{{ errors.challenge_duration_days }}</div>
              </div>
            </ng-container>

            <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().has_mailchimp_integration">
              <h3 class="mt-2">Mailchimp Events</h3>

              <p class="text-muted">
                To learn more, see our
                <a href="https://capitan.helpscoutdocs.com/article/200-mailchimp-events-and-tags"
                   target="_blank" rel="noopener">support article on the Capitan Mailchimp integration</a>.
              </p>

              <p class="text-muted">
                Capitan does not sync any automatic Mailchimp events for challenges; only the custom events configured below are synced.
              </p>

              <div class="form-group">
                <label for="mailchimpAddedToChallengeEventNameInput">"Added To Challenge" Event Name</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpAddedToChallengeEventNameInput"
                           type="text"
                           name="mailchimp_added_to_challenge_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="challenge.mailchimp_added_to_challenge_event_name">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp whenever a customer is added to this challenge (either manually or automatically).
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_added_to_challenge_event_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpChallengeCompletedEventNameInput">"Challenge Completed" Event Name</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpChallengeCompletedEventNameInput"
                           type="text"
                           name="mailchimp_challenge_completed_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="challenge.mailchimp_challenge_completed_event_name">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp whenever a customer completes this challenge.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_challenge_completed_event_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpChallengeExpiredEventNameInput">"Challenge Expired" Event Name</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpChallengeExpiredEventNameInput"
                           type="text"
                           name="mailchimp_challenge_expired_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="challenge.mailchimp_challenge_expired_event_name">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp whenever a customer reaches the end of this challenge without completing it.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_challenge_completed_event_name }}</div>
              </div>
            </ng-container>

            <div class="form-group">
              <label for="will_prompt_for_prize">Should staff be prompted to give a prize when a customer completes this challenge?</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <select class="custom-select"
                          [(ngModel)]="challenge.will_prompt_for_prize"
                          id="will_prompt_for_prize" name="will_prompt_for_prize">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.will_prompt_for_prize }}</div>

              <div *ngIf="challenge.will_prompt_for_prize"
                   class="pl-3 mt-3" style="border-left: 3px solid #dee2e6">
                <div class="row">
                  <div class="col-lg-10">
                    <label for="rewardInstructionsTextArea">Reward Instructions (optional)</label>
                    <textarea id="rewardInstructionsTextArea" name="reward_instructions"
                              class="form-control"
                              [(ngModel)]="challenge.reward_instructions"></textarea>
                  </div>
                </div>
                <small class="form-text text-muted">
                  This is shown to staff only, in the prize prompt when a customer completes the challenge. It is never shown to customers. To tell customers about the reward, use the Description and Details fields above.
                </small>
                <div class="form-text text-danger">{{ errors.reward_instructions }}</div>
              </div>
            </div>

            <div class="form-group">
              <label for="challenge_completion_association_id">Challenge Completion Association</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <select id="challenge_completion_association_id_loading" class="custom-select"
                          name="challenge_completion_association_id"
                          *ngIf="loadingAssociations" disabled>
                    <option>Loading...</option>
                  </select>
                  <select id="challenge_completion_association_id" class="custom-select"
                          name="challenge_completion_association_id"
                          *ngIf="!loadingAssociations"
                          [(ngModel)]="challenge.challenge_completion_association_id">
                    <option [ngValue]="null" class="text-muted">None</option>
                    <option *ngFor="let association of associations"
                            [ngValue]="association.id">
                      {{ association.name }}
                    </option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                Customers will be added to the chosen association when they complete this challenge.
              </small>
              <div class="form-text text-danger">{{ errors.challenge_completion_association_id }}</div>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>
